import api from './api';

export const projectService = {
  getAll: (params = {}) => api.get('/projects/', { params }),
  getById: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/projects/', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  updateStatus: (id, status, progress, notes, statusChangedAt) => api.put(`/projects/${id}/status`, { status, progress, notes, status_changed_at: statusChangedAt }),
  updateStatusDate: (id, statusChangedAt) => api.put(`/projects/${id}/status-date`, { status_changed_at: statusChangedAt }),
  getStatusManagement: (params = {}) => api.get('/projects/status-management', { params }),
  inlineUpdate: (id, updates) => api.put(`/projects/inline-update/${id}`, updates),
  addMaterial: (id, material) => api.post(`/projects/${id}/materials`, material),
  updateMaterial: (id, materialIndex, material) => api.put(`/projects/${id}/materials/${materialIndex}`, material),
  deleteMaterial: (id, materialIndex) => api.delete(`/projects/${id}/materials/${materialIndex}`),
  addReceipt: (id, receipt) => api.post(`/projects/${id}/receipts`, receipt),
  updateReceipt: (id, receiptIndex, receipt) => api.put(`/projects/${id}/receipts/${receiptIndex}`, receipt),
  deleteReceipt: (id, receiptIndex) => api.delete(`/projects/${id}/receipts/${receiptIndex}`),
  addChangeOrder: (id, changeOrder) => api.post(`/projects/${id}/change-orders`, changeOrder),
  updatePayment: (id, paymentNumber, paymentData) => api.put(`/projects/${id}/payments/${paymentNumber}`, paymentData),
  insertExtraPayment: (id, description) => api.post(`/projects/${id}/payments/insert-extra`, { description: description || null }),
  deleteExtraPayment: (id, paymentNumber) => api.delete(`/projects/${id}/payments/${paymentNumber}`),
  addNote: (id, note) => api.post(`/projects/${id}/notes`, note),
  deleteNote: (id, noteIndex) => api.delete(`/projects/${id}/notes/${noteIndex}`),
  delete: (id) => api.delete(`/projects/${id}`),
  getStats: () => api.get('/projects/stats/overview'),
};
